(function () {
  if (window.BZCollectionSlider && typeof window.BZCollectionSlider.initAll === 'function') {
    window.BZCollectionSlider.initAll(document);
    return;
  }

  function getCards(track) {
    return Array.prototype.slice.call(track.querySelectorAll('[data-bz-slider-card]'));
  }

  function getGap(track) {
    var styles = window.getComputedStyle(track);
    return parseFloat(styles.columnGap || styles.gap || '0') || 0;
  }

  function getVisibleCards(track, cards) {
    if (!cards.length) return 1;

    var cardWidth = cards[0].getBoundingClientRect().width;
    var trackWidth = track.getBoundingClientRect().width;
    var gap = getGap(track);

    if (!cardWidth || !trackWidth) return 1;

    return Math.max(1, Math.floor((trackWidth + gap) / (cardWidth + gap)));
  }

  function getCurrentIndex(track, cards) {
    if (!cards.length) return 0;

    var trackLeft = track.getBoundingClientRect().left;
    var current = 0;
    var closestDistance = Number.POSITIVE_INFINITY;

    cards.forEach(function (card, index) {
      var distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        current = index;
      }
    });

    return current;
  }

  function selectCard(track, cards, index) {
    if (!cards.length) return;

    var maxIndex = cards.length - 1;
    var nextIndex = Math.max(0, Math.min(index, maxIndex));
    var card = cards[nextIndex];
    var trackLeft = track.getBoundingClientRect().left;
    var cardLeft = card.getBoundingClientRect().left;
    var nextScrollLeft = track.scrollLeft + cardLeft - trackLeft;

    track.scrollTo({
      left: nextScrollLeft,
      behavior: 'smooth',
    });
  }

  function initSlider(root) {
    if (!root || root.dataset.bzSliderReady === 'true') return;

    var track = root.querySelector('[data-bz-slider-track]');
    var footer = root.querySelector('[data-bz-slider-footer]');
    var progressRail = footer ? footer.querySelector('.bz-collection-slider__progress') : null;
    var progress = root.querySelector('[data-bz-slider-progress]');
    var previousButton = root.querySelector('[data-bz-slider-action="previous"]');
    var nextButton = root.querySelector('[data-bz-slider-action="next"]');
    var mobileProgressFooter = root.querySelector('[data-bz-slider-mobile-progress-footer]');
    var mobileProgressRail = mobileProgressFooter
      ? mobileProgressFooter.querySelector('.bz-collection-slider__mobile-progress')
      : null;
    var mobileProgress = root.querySelector('[data-bz-slider-mobile-progress]');

    if (!track || !footer || !progressRail || !progress) return;

    root.dataset.bzSliderReady = 'true';

    function update() {
      var cards = getCards(track);
      var visibleCards = getVisibleCards(track, cards);
      var maxIndex = Math.max(cards.length - visibleCards, 0);
      var currentIndex = Math.min(getCurrentIndex(track, cards), maxIndex);
      var maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
      var currentScroll = Math.min(Math.abs(track.scrollLeft), maxScroll);
      var progressWidth = cards.length > 0 ? Math.min((visibleCards / cards.length) * 100, 100) : 100;

      progress.style.width = progressWidth + '%';

      var progressTravel = Math.max(progressRail.clientWidth - progress.offsetWidth, 0);
      var progressPosition = maxScroll > 0 ? (currentScroll / maxScroll) * progressTravel : 0;

      progress.style.left = progressPosition + 'px';
      footer.classList.toggle('is-static', maxScroll <= 1);

      if (mobileProgressFooter && mobileProgressRail && mobileProgress) {
        var mobileProgressTravel = Math.max(mobileProgressRail.clientWidth - mobileProgress.offsetWidth, 0);
        var mobileProgressPosition = maxScroll > 0 ? (currentScroll / maxScroll) * mobileProgressTravel : 0;

        mobileProgressFooter.hidden = maxScroll <= 1;
        mobileProgress.style.left = mobileProgressPosition + 'px';
      }

      if (previousButton) {
        previousButton.disabled = currentIndex <= 0;
      }

      if (nextButton) {
        nextButton.disabled = currentIndex >= maxIndex;
      }
    }

    root.addEventListener('click', function (event) {
      var button = event.target && event.target.closest ? event.target.closest('[data-bz-slider-action]') : null;
      if (!button || !root.contains(button)) return;

      event.preventDefault();

      var cards = getCards(track);
      var visibleCards = getVisibleCards(track, cards);
      var maxIndex = Math.max(cards.length - visibleCards, 0);
      var currentIndex = Math.min(getCurrentIndex(track, cards), maxIndex);
      var direction = button.getAttribute('data-bz-slider-action');
      var nextIndex = direction === 'previous' ? currentIndex - 1 : currentIndex + 1;

      selectCard(track, cards, Math.max(0, Math.min(nextIndex, maxIndex)));
    });

    var scrollFrame;
    track.addEventListener('scroll', function () {
      if (scrollFrame) return;

      scrollFrame = window.requestAnimationFrame(function () {
        update();
        scrollFrame = null;
      });
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(update, 120);
    });

    update();
  }

  function initAll(container) {
    var scope = container || document;
    var sliders = scope.querySelectorAll('[data-bz-collection-slider]');

    sliders.forEach(initSlider);
  }

  window.BZCollectionSlider = {
    initAll: initAll,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
